const Users = {
  loginPath: () => '/api/session',
  signUpPath: () => '/api/registration',
  confirmationPath: () => '/api/confirmation',
  passwordPath: () => '/api/password',
  accountDetailsPath: () => '/api/account_details',
  loginPathAgency: () => '/AgencyUser/SignInAgencyUser ',
  loggedInUser: () => '/AgencyUser/LoggedInUser',
  loginPinpadPath: () => '/AgencySitefTerminal/Configuration',
};

export default Users;
